import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { RecoilRoot } from "recoil";
import { BrowserRouter, useNavigate } from "react-router-dom";
import Router from "./pages/router";
import { SetupInterceptors } from "./services/baseHttp";
import { notification } from "antd";
import { NotificationType } from "./types/general.types";
import { ConfigProvider } from "antd";
import { I18nextProvider } from "react-i18next";
import translation from "./translation";
import { language } from "./assets/translation/antTranslation";
import { locales } from "./assets/translation/antTranslation";
import { getColorByType, getMessageByType } from "./utils/message.utils";
import sixConfig from "./sixConfig";
import { useTranslation } from "react-i18next";
import { Theme, ThemeConfig } from "antd/es/config-provider/context";
import { BgColorsOutlined } from "@ant-design/icons";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

function NavigateFunctionComponent() {
  let navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [ran, setRan] = useState(false);
  const [api, contextHolder] = notification.useNotification({
    maxCount: 2,
  });
  const openNotificationWithIcon = (type: NotificationType, code: string) => {
    console.log(type);
    api[type]({
      message: `${t(code)}`,
      duration: ["error"].includes(type) ? 3 : 1,
    });
  };
  if (!ran) {
    SetupInterceptors(navigate, openNotificationWithIcon);
    setRan(true);
  }
  return <>{contextHolder}</>;
}

const theme = {
  components: {
    Steps: {
      fontSize: 12,
      navArrowColor: "#f5f5f5",
    },
  },
};

root.render(
  <I18nextProvider i18n={translation} defaultNS={["translation"]}>
    <ConfigProvider
      locale={locales[language.replace("-", "_")]}
      theme={{
        token: {
          // colorPrimary: 'red'
        },
        components: {
          Steps: {
            fontSize: 12,
            navArrowColor: "#f5f5f5",
            colorPrimary: 'transparent',
            colorTextSecondary: 'transparent',
            colorSplit:  'transparent',
          },
          Radio: {
            buttonBg: "#FFF",

          },
          Tabs: {
            inkBarColor: 'transparent',
          },
          Button: {
            defaultActiveBg: 'rgb(0, 90, 118)',
          }
        }
      }}
      // theme={{

      //   token: {
      //     colorPrimary: "#003a70",
      //     borderRadius: 4,
      //     colorBgContainer: "#FFF",
      //     colorBorder: "#E0E8F5",
      //     colorTextHeading: "#9ca3af",
      //   },
      //   // components: {
      //   //   Table: {

      //   //      // Cambia il colore di sfondo dell'header della tabella
      //   //     paddingContentHorizontal: 1, // Horizontal padding for table cells
      //   //     paddingContentVertical: 1, // Vertical padding for table cells
      //   //     colorFillAlter: "#f5f5f5", // Background color for table cells
      //   //     paddingContentVerticalLG: 1, // Vertical padding for table cells in large size
      //   //     paddingContentHorizontalLG: 1, // Horizontal padding for table cells in large size
      //   //     paddingContentVerticalSM: 1, // Vertical padding for table cells in small size
      //   //     paddingContentHorizontalSM: 1, // Horizontal padding for table cells in small size
      //   //     fontSize: 4, // Font size for table cells
      //   //     fontSizeLG: 4, // Font size for table cells in large size
      //   //     fontSizeSM: 4, // Font size for table cells in small size
      //   //     colorFill: "#fff", // Background color for table cells
      //   //   },
      //   // },
      // }}
    >
      <React.StrictMode>
        <RecoilRoot>
          <BrowserRouter basename={sixConfig.BASENAME}>
            {<NavigateFunctionComponent />}
            <Router />
          </BrowserRouter>
        </RecoilRoot>
      </React.StrictMode>
    </ConfigProvider>
  </I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
